/***
 * Created on 2024/4/15
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React, {useReducer} from 'react';
import ModalDialog from "../common/modal_dialog/modalDialog";
import sharedI18n from "common/SharedI18n";
import {useTranslation, I18nextProvider} from "react-i18next";
import InitQnapAuthAppSetup from "./two_step/two_step_verification/qnap_auth_app/init_qnap_auth_app_setup";
import InstallQnapAuthApp from "./two_step/two_step_verification/qnap_auth_app/install_qnap_auth_app";
import ScanQrCode from "./two_step/two_step_verification/qnap_auth_app/scan_qr_code";
import QnapAuthAppApproval from "./two_step/two_step_verification/qnap_auth_app/qnap_auth_app_approval";
import BindQnapAuthAppSuccess from "./two_step/two_step_verification/qnap_auth_app/bind_qnap_auth_app_success";
import ShowSigninAgainDialog from "../common/modal_dialog/show_signin_again_dialog";
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {qnapAuthReducer, initState} from "../../service/qnap_auth_reducer";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false, // default: true
        },
    },
});


function Force2FaSetup(props) {
    const { t } = useTranslation();
    const [state, dispatch] = useReducer(qnapAuthReducer, initState);

    return (
        <>
            <I18nextProvider i18n={sharedI18n} >
                <QueryClientProvider client={queryClient}>
                    <ModalDialog {...props} showModal={true} title={t('@Protect your account with 2-Step Verification@')} submitText={t('@Safety Comes First@')} hideCancel={true} submitAction={() => dispatch({type: 'toggleShowInitQnapAuthAppSetup', value: true})}>
                        <div className="dialog-content">
                            <p>
                                {t('@Your security on QNAP Cloud Services is our top priority. Use 2-Step Verification to protect QID account from unauthorized access. You can whether receive a text message or hook it up to your authenticator app.@')}
                            </p>
                            <p>
                                {t('@For you account security, please consider setting up your 2-Step Verification today.@')}
                            </p>
                        </div>
                    </ModalDialog>

                    {state.showInitQnapAuthAppSetup && <InitQnapAuthAppSetup showModal={state.showInitQnapAuthAppSetup} closeModal={()=>dispatch({type: 'toggleShowInitQnapAuthAppSetup', value: false})} dispatch={dispatch} hideCancel={true} />}
                    {state.showInstallApp && <InstallQnapAuthApp showModal={state.showInstallApp} closeModal={()=>dispatch({type: 'toggleShowInstallApp', value: false})} dispatch={dispatch} state={state}/>}
                    {state.showQrCodeScan && <ScanQrCode showModal={state.showQrCodeScan} closeModal={()=>dispatch({type: 'toggleShowQrCodeScan', value: false})} dispatch={dispatch} state={state}/>}
                    {state.showApproval && <QnapAuthAppApproval showModal={state.showApproval} closeModal={()=>dispatch({type: 'toggleShowApproval', value: false})} dispatch={dispatch} state={state}/>}
                    {state.showSuccess && <BindQnapAuthAppSuccess showModal={state.showSuccess} closeModal={()=>dispatch({type: 'toggleShowSuccess', value: false})} dispatch={dispatch} state={state}/>}
                    {state.showSigninAgain && <ShowSigninAgainDialog showModal={state.showSigninAgain} closeModal={()=>dispatch({type: 'toggleSigninAgain', value: false})} />}

                </QueryClientProvider>
            </I18nextProvider>
        </>
    );
}

export default Force2FaSetup;